/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const Arrow600Icon = ({ width = 24, height = 24, hidden = false, title = 'Arrow600' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
    width="${width}"
    height="${height}"
  >
    <path
      d="m18.191 9.241-5.986-5.987a1.073 1.073 0 0 0-1.518 1.517l4.155 4.156H2.063a1.073 1.073 0 1 0 0 2.146h12.779l-4.154 4.155a1.073 1.073 0 1 0 1.517 1.518l5.986-5.987a1.073 1.073 0 0 0 0-1.518"
    />
  </svg>`;
};
